import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("rect", {
        width: "39",
        height: "25",
        x: ".5",
        y: ".5",
        fill: "#F6F6F6",
        stroke: "#424446",
        "stroke-opacity": ".25",
        rx: "4"
      }),
      _createElementVNode("path", {
        fill: "#424446",
        "fill-opacity": ".25",
        d: "M1 6h38v6H1z"
      })
    ], -1)
  ]))]))
}
export default { render: render }